import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import Image from 'next/image';
import React from 'react';

import s from 'components/basic/PlansInfoTable/PlansInfoTable.module.scss';

interface Props {
  text: string;
  allowInFree: boolean;
}

export default function Row({ text, allowInFree }: Props): JSX.Element {
  const t = useTranslationAndTypograph();

  return (
    <div className={cn(s.row)}>
      <span>{t(text)}</span>
      <span>
        <Image
          width={40}
          height={40}
          src={`/pagesImages/payments/PlansPage/${
            allowInFree ? 'check' : 'minus'
          }.svg`}
        />
      </span>
      <span>
        <Image
          width={40}
          height={40}
          src="/pagesImages/payments/PlansPage/check.svg"
        />
      </span>
    </div>
  );
}
